import { Logo } from '../Logo.tsx';
import type { SiteConfig } from '../../siteContentTypes.ts';

export function LandingFooter({ config }: { config: SiteConfig }) {
  return (
    <footer style={{ borderTop: '1px solid var(--border)', padding: '48px 24px 28px' }}>
      <div style={{ maxWidth: 1160, margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 32, marginBottom: 32 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <Logo size={26} />
            <p style={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.5, margin: 0, maxWidth: 220 }}>
              {config.footer.description}
            </p>
          </div>
          {config.footer.columns.map((col) => (
            <div key={col.title} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <div style={{ fontWeight: 800, fontSize: 13 }}>{col.title}</div>
              {col.links.map((link) => (
                <a key={link.label} href={link.url} style={{ fontSize: 13, color: 'var(--text-secondary)', textDecoration: 'none' }}>
                  {link.label}
                </a>
              ))}
            </div>
          ))}
        </div>
        <div style={{ borderTop: '1px solid var(--border)', paddingTop: 18, fontSize: 12, color: 'var(--text-tertiary)', textAlign: 'center' }}>
          {config.general.copyrightText}
        </div>
      </div>
    </footer>
  );
}
